<template>
  <div>
    <br />
    <h1>Bienvenue au club de développement de jeux vidéo de l'Université Laval</h1>
    <br />
    <h4 style="text-align: left;margin-right: 30px;margin-left: 30px;">
      Le club de développement de jeux vidéo de l'Université Laval a pour objectif d'enrichir les connaissances en création de jeux vidéo
      des étudiants de la faculté des sciences et génie. Pour ce faire, le club propose des formations,
      des séances de travail et des conférences avec des professionnels de l'industrie. Ses membres sont encouragés à participer à des concours dans le but de réaliser des projets vidéoludiques.
    </h4>
    <br />

    <!--Carousel Wrapper-->
    <div class = "carousel-wrapper">
      <div id="carousel-project-images" class="carousel slide carousel-fade" data-ride="carousel" data-interval="5000">

        <!--Indicators-->
        <ol class="carousel-indicators">
          <li data-target="#carousel-project-images" data-slide-to="0" class="active"></li>
          <li data-target="#carousel-project-images" v-for="(project,index) in projects" v-bind:key="index" :data-slide-to="index+1"></li>
        </ol>
        <!--/.Indicators-->

        <!--Slides-->
        <div class="carousel-inner" role="listbox">
          <div class="carousel-item active">
            <div class="embed-responsive embed-responsive-16by9">
              <img class="embed-responsive-item" v-bind:src="require('@/assets/home/logo_cdjvul_1920x1080.png')" alt="Image introuvable" />
            </div>
            <div class="carousel-caption"></div>
          </div>
          <div class="carousel-item" v-for="(project,index) in projects" v-bind:key="index">
            <div class="embed-responsive embed-responsive-16by9">
              <img class="embed-responsive-item" v-bind:src="require(`@/assets/projects/${project.mainImagePath}`)" alt="Image introuvable" />
            </div>
            <div class="carousel-caption"></div>
          </div>
        </div>
        <!--/.Slides-->

        <!--Controls-->
        <a class="carousel-control-prev" href="#carousel-project-images" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carousel-project-images" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
        <!--/.Controls-->

      </div>
    </div>
    <!--/.Carousel Wrapper-->

    <div class="card-deck">
      <div class="card bg-dark">
        <div class="card-body text-center">
          <h3 class="card-text">Restez à jour sur les événements</h3>
          <div>
            <br />
            <a href="https://www.facebook.com/gamedevUlaval/" target="_blank">
              <div>
                <img v-bind:src="require('@/assets/home/Facebook.svg.png')" class="icons-link rounded-lg" />
                <a href="https://www.facebook.com/gamedevUlaval/" target="_blank" class="icon-box">Facebook</a>
              </div>
            </a>
            <br />
            <!-- <a href="https://cfi-ul.slack.com/" target="_blank">
              <div>
                <img v-bind:src="require('@/assets/home/slack-logo-icon.png')" class="icons-link rounded-lg bg-light" />
                <a href="https://cfi-ul.slack.com/" target="_blank" class="icon-box">Slack</a>
              </div>
            </a>
            <br /> -->
            <a href="https://discord.gg/5Ca3QUXrk4" target="_blank">
              <div>
                <img v-bind:src="require('@/assets/home/discord.jpg')" class="icons-link rounded-lg" />
                <a href="https://discord.gg/5Ca3QUXrk4" target="_blank" class="icon-box">Discord</a>
              </div>
            </a>
            <br />
            <a style="font-size: 1.75rem" href="https://docs.google.com/forms/d/e/1FAIpQLSfM7rsdwywJ00xK1Kmowq59YvUX-SsID-as5uY6ghEOJ0o-TA/viewform?usp=pp_url">Inscrivez-vous officiellement au club ici!</a>
          </div>
        </div>
      </div>
      <div class="card bg-dark">
        <div class="card-body text-center">
          <h3 class="card-text">Responsable du club</h3>
          <br />
          <img class="spotlight" alt="Image introuvable" v-bind:src="require('@/assets/home/emmanuel_coutlee.jpg')" />
          <br />
          <br />
          <p>Emmanuel Coutlée</p>
          <p>Étudiant à la maîtrise en Intelligence Artificielle</p>
        </div>
      </div>
      <div class="card bg-dark">
        <div class="card-body text-center">
          <h3 class="card-text">Où nous trouver?</h3>
          <p>1065 avenue de la Médecine, Québec, Canada</p>
          <p>Pavillon Adrien-Pouliot</p>
          <p>Local PLT-3778</p>
          <br />
          <br />
          <h3>Heures d'ouverture du local</h3>
          <p>À déterminer</p>
          <br />
          <br />
          <h3>Pour nous contacter</h3>
          <p>gamedev.admin@ift.ulaval.ca</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as projectsDataFile from "../projects/Projects.js";

export default {
  name: "Home",
  data: () => ({
    projects: [],
  }),

  async created() {
    this.projects = projectsDataFile.projects;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-deck {
    padding: 2rem;
}

.spotlight {
  border-radius: 50%;
  width: 100%;
  max-width: 250px;
  object-fit: contain;
}
.icons-link {
  width: 100%;
  max-width: 100px;
  object-fit: contain;
  display: inline-block;
}

.icon-box {
  width: 50%;
  display: inline-block;
  color: white;
}

p {
  margin: 0;
}

.carousel-wrapper{
  display: flex;
  justify-content: center;
}

.carousel {
  padding-bottom: 15px;
  width: 60%;
}

/* On screens that are 992px or less, make image carousel take up 100% of screen width */
@media screen and (max-width: 992px) {
  .carousel {
    width: 95%;
  }
}
</style>
